/**
 * 售后中心-商品评价数据分析
 */

import { post, get, deleteApi, postJson, postUrl } from '../axios'

const RESOURCE_BASE_PATH = '/popCommentWareAnalysis/'

const RESOURCE_BASE_PATH1 = '/popCommentWareAnalysis/'

// 商品评价分析的更新
export const queryGetArticleDaysSummary = p => post(`${RESOURCE_BASE_PATH}getArticleDaysSummary`, p);

// 计算好评
export const calculateGoodComment = p => get(`${RESOURCE_BASE_PATH}calculateGoodComment`, p);

// 导出好评统计
export const exportGood = p => post(`${RESOURCE_BASE_PATH}export`,p);

// 商品评价数据分析列表
export const getList = p => get(`${RESOURCE_BASE_PATH}getPopCommentWareAnalysisList`, p);

// 查询商品评价历史
export const querygetWarePopCommentAnalysisDetail = p => get(`${RESOURCE_BASE_PATH1}getWarePopCommentAnalysisDetail`, p);

// 店家商品信息的同步
export const synchroJdWare = p => post(`${RESOURCE_BASE_PATH}synchroJdWare`, p);

// 商品评价分析的更新
export const goodsUpdate = p => postUrl(`${RESOURCE_BASE_PATH}updateWarePopCommentAnalysis`, p);

// 全店商品评价分析开关
export const goodsSwitch = p => postJson(`${RESOURCE_BASE_PATH}updateWarePopCommentAnalysisSwitch`, p);

// 好评商品统计
export const wareGoodCount = p => get(`${RESOURCE_BASE_PATH}wareGoodPopCommentStatistics`, p);